import moment from "moment-timezone";

export const getCurrentIanaTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const timezonesForSearch = [
  "Africa/Johannesburg",
  "America/Argentina/Buenos_Aires",
  "America/Chicago",
  "America/Denver",
  "America/Detroit",
  "America/Edmonton",
  "America/Halifax",
  "America/Los_Angeles",
  "America/Mexico_City",
  "America/Montreal",
  "America/New_York",
  "America/Phoenix",
  "America/Regina",
  "America/Sao_Paulo",
  "America/Toronto",
  "America/Vancouver",
  "America/Winnipeg",
  "Asia/Bangkok",
  "Asia/Dhaka",
  "Asia/Dubai",
  "Asia/Hong_Kong",
  "Asia/Jakarta",
  "Asia/Kolkata",
  "Asia/Kuala_Lumpur",
  "Asia/Kuwait",
  "Asia/Manila",
  "Asia/Riyadh",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Tehran",
  "Asia/Tokyo",
  "Australia/Brisbane",
  "Australia/Sydney",
  "Europe/Amsterdam",
  "Europe/Athens",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Copenhagen",
  "Europe/Helsinki",
  "Europe/London",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Warsaw",
  "Europe/Zurich",
];

type DisplayTypes = "default" | "abbreviation";

export const displayTimezone = (
  timezone: string,
  displayType: DisplayTypes = "default"
) => {
  const tz = moment.tz.zone(timezone);

  if (!tz) return null;

  const formattedName = tz.name.replace(/_/g, " ");
  const abbreviation = tz.abbr(new Date().getTime());

  if (displayType === "abbreviation") {
    return abbreviation;
  }

  return `${formattedName} (${abbreviation})`;
};

export const getTimezoneOffset = (timezone: string) => {
  const timezoneOffset = moment().tz(timezone).utcOffset();
  const hours = Math.floor(Math.abs(timezoneOffset) / 60);
  const minutes = Math.abs(timezoneOffset) % 60;
  const sign = timezoneOffset >= 0 ? "+" : "-";

  return `UTC${sign}${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};
